import { gql, useMutation } from '@apollo/client';
import { ignoreNextLocalLogout } from '../account/localLogout';
import { SessionActions } from '../account/sessionSlice';
import { useAppDispatch } from '../app/redux/useAppSelector';
import CURRENT_SESSION_FRAGMENT from '../graphql/fragments/CurrentSession';
import type {
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables,
} from '../graphql/generated/graphqlTypes';

const UPDATE_PASSWORD_MUTATION = gql`
  mutation updatePassword($password: String!, $oldPassword: String) {
    updatePassword(password: $password, oldPassword: $oldPassword) {
      ...CurrentSession
    }
  }
  ${CURRENT_SESSION_FRAGMENT}
`;

const useUpdatePasswordMutation = () => {
  const dispatch = useAppDispatch();
  const [mutate] = useMutation<
    UpdatePasswordMutation,
    UpdatePasswordMutationVariables
  >(UPDATE_PASSWORD_MUTATION, {
    onCompleted(data) {
      dispatch(SessionActions.clearSession());
      dispatch(SessionActions.startSession(data.updatePassword));
    },
  });

  return (variables: UpdatePasswordMutationVariables) => {
    ignoreNextLocalLogout();
    return mutate({ variables });
  };
};

export default useUpdatePasswordMutation;
